import React from "react";


export default function ListPreview({ list, onOpen }) {
    if (!list) return null;
    return (
        <div className="mt-3 space-y-2">
            <div className="font-medium">{list.prompt}</div>
            <button className="btn btn-outline-primary btn-sm" onClick={() => onOpen(list)}>
                {list.button}
            </button>
        </div>
    );
}
